import React from "react";

const SelectInput = (props) => {
  return (
    <>
      {props.label && (
        <label
          className={`e-primary-font-poppins e-font-weight-400 e-font-16 ${
            props.labelStyle
              ? props.labelStyle
              : props.error && props.require
              ? "e-text-cg-red"
              : "e-text-black "
          }`}
        >
          {props.label}
          {props.require && !props.error && (
            <span className="text-danger">*</span>
          )}
        </label>
      )}
      <div className="d-flex align-items-center column-gap-2 flex-wrap position-relative row-gap-2">
        {props.options.map((elem, idx) => {
          const isActive = props.value === elem;
          return (
            <div
              key={idx}
              className={`e-border-radius-100px px-3 py-1 e-cursor-pointer ${
                isActive
                  ? "e-border-1-12px-vodka e-bg-lavender-web "
                  : "e-bg-bright-gray e-border-1-12px-chinese-white-light"
              }`}
              onClick={() => props.onSelect && props.onSelect(elem)}
            >
              <p
                className={`e-font-weight-400 text-capitalize m-0 e-primary-font-poppins e-font-15 ${
                  isActive ? "e-text-purple" : "e-text-silver-chalice"
                }`}
              >
                {elem}
              </p>
            </div>
          );
        })}
        {/* {props.error && (
          <label
            className={
              " position-absolute bottom-20 e-text-cg-red pos e-primary-font-poppins e-font-weight-400   e-font-12"
            }
          >
            Select an Option
          </label>
        )} */}
      </div>
    </>
  );
};

SelectInput.defaultProps = {
  onSelect: () => {},
  type: 1,
};

export default SelectInput;
